import React, { useEffect, useRef, useState } from "react";
import sprite from "../../assets/icons.svg";
import { QISimpleSearch } from "../QISimpleSearch";
import { QICollapsible } from "../QICollapsible";
import { QIAdvanceSearch } from "../QIAdvanceSearch";

export const QIExpand = ({
  title,
  children,
  setDockAlign,
  setMapExpand,
  simpleSearch,
  setSimpleSearch,
  setDetails,
  setDeviceId = () => {},
  simpleSearchPlaceholder,
  alternativeUI,
  setSelectedRowId = () => {},
  advanceSearch,
  setAdvanceSearch,
  AdvanceSearchComponent,
  advanceSearchProps,
  disableSimpleSearch,
  selectedPlateNumbers = [],
  onClearFilter,
  onClearAllFilters,
  subNavigation,
}) => {
  const [expand, setExpand] = useState(false);
  const [showAdvanceSearch, setShowAdvanceSearch] = useState(false);

  const simpleSearchRef = useRef(null);
  const advanceSearchRef = useRef(null);

  const handleExpand = () => {
    setExpand((prevState) => !prevState);
    setMapExpand(!expand);
  };

  const handleAdvanceSearchToggle = () => {
    if (AdvanceSearchComponent) {
      setShowAdvanceSearch(!showAdvanceSearch);
    }
  };

  const handleAdvanceSearch = (searchData) => {
    if (setAdvanceSearch) {
      setAdvanceSearch(searchData);
    }
    setShowAdvanceSearch(false);
  };

  // Reset map and clear device selection when simple search is cleared
  const handleSearchClear = () => {
    setDeviceId(null);
    setDetails(false);
    setDockAlign("cross");
    setSelectedRowId(null);
  };

  const handleClickOutside = (event) => {
    const closeButton = simpleSearchRef.current ? simpleSearchRef.current.querySelector('.icon.icon-cross') : null

    if (
      (advanceSearchRef.current && !advanceSearchRef.current.contains(event.target)) &&
      (simpleSearchRef.current && !simpleSearchRef.current.contains(event.target))
    ) {
      setShowAdvanceSearch(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Reset map and clear device selection when searched
  useEffect(() => {
    setDeviceId(null);
    setDetails(false);
    setDockAlign("cross");
    setSelectedRowId(null);
  }, [simpleSearch]);

  return (
    <>
      {expand ? (
        <div className="qi-collapsed" onClick={handleExpand}>
          {alternativeUI && (
            <span className="qi-collapsed_icon">
              <svg className="icon rotate-180">
                <use href={`${sprite}#collapse`}></use>
              </svg>
            </span>
          )}
          {!alternativeUI && (
            <span className="qi-collapsed_icon">
              <svg className="icon">
                <use href={`${sprite}#collapse`}></use>
              </svg>
            </span>
          )}

          <span className="qi-collapsed_text">{title}</span>
        </div>
      ) : (
        <aside className="qi-expanded map-view-flyout">
          <header className="qi-expanded_header">
            {!alternativeUI && (
              <span onClick={handleExpand} className="collapse-icon-wrapper">
                <svg className="icon rotate-180">
                  <use href={`${sprite}#collapse`}></use>
                </svg>
              </span>
            )}
            <strong className="qi-expanded_header_title">{title}</strong>
            <QISimpleSearch
              ref={simpleSearchRef}
              searchKey={simpleSearch}
              handleSearchChange={setSimpleSearch}
              simpleSearchPlaceholder={simpleSearchPlaceholder}
              setDetails={setDetails}
              setDockAlign={setDockAlign}
              setDeviceId={setDeviceId}
              tracking={true}
              advanceSearch={advanceSearch}
              handleSearchClear={handleSearchClear}
              handleAdvanceSearchToggle={
                AdvanceSearchComponent ? handleAdvanceSearchToggle : undefined
              }
              showAdvanceSearch={AdvanceSearchComponent ? showAdvanceSearch : undefined}
              disabled={disableSimpleSearch}
              selectedPlateNumbers={selectedPlateNumbers}
              onClearFilter={onClearFilter}
              onClearAllFilters={onClearAllFilters}
            />
            {alternativeUI && (
              <span onClick={handleExpand} className="collapse-icon-wrapper">
                <svg className="icon">
                  <use href={`${sprite}#collapse`}></use>
                </svg>
              </span>
            )}
          </header>
          <QIAdvanceSearch
            ref={advanceSearchRef}
            showAdvanceSearch={showAdvanceSearch}
            setShowAdvanceSearch={setShowAdvanceSearch}
            advanceSearch={advanceSearch}
            setAdvanceSearch={setAdvanceSearch}
            AdvanceSearchComponent={AdvanceSearchComponent}
            advanceSearchProps={advanceSearchProps}
            onClearFilter={onClearFilter}
            onClearAllFilters={onClearAllFilters}
          />

          {/* {subNavigation} */}
          <div className="qi-expanded_body asset-list-wrapper">{children}</div>
        </aside>
      )}
    </>
  );
};
